import { getIsBundleDevops, Product } from '@atlassiansox/bxpkit-core';

import { includesProduct } from './sign-up-layout-container';

export interface GetTintinMvpEnabledOverrideValueParams {
  productKeys: Array<{ product?: string | null }>;
  isMigrationSignup: boolean;
  enableTintinMvp: boolean | undefined;
}

export function getTintinMvpEnabledOverrideValue(
  params: GetTintinMvpEnabledOverrideValueParams
) {
  const hasBitbucket = includesProduct({
    products: params.productKeys,
    productName: 'com.atlassian.bitbucket'
  });

  const isBundleDevops = getIsBundleDevops(params.productKeys as Product[]);

  if (hasBitbucket || params.isMigrationSignup || isBundleDevops) {
    return params.enableTintinMvp;
  }

  return true;
}
